import { useContext } from 'react';
import { SplitContext, useTreatments } from '@splitsoftware/splitio-react';
import { FeatureToggleContext } from './provider';

function useFeatureToggleReadyStatus(): boolean {
  const splitContext = useContext(SplitContext);
  return splitContext.isReady;
}

function useFeatureToggle(flag: string): boolean {
  const attributes = useContext(FeatureToggleContext) as { email?: string };
  const key = attributes.email ?? 'anonymous';
  const { treatment } = useTreatments([flag], attributes, key)[flag];

  return treatment === 'on';
}

export { useFeatureToggleReadyStatus, useFeatureToggle };
